import type { AllRouteEndpoints } from "../routeTypes";

export const engagementAsyncSegmentInsightsActualStats = "/engagement/async/segment_insights_actual_stats" as const;
export const engagementAsyncSegmentInsightsActualStatsKey: AllRouteEndpoints[] = [
  engagementAsyncSegmentInsightsActualStats,
];
